export default "__VITE_ASSET__0d1cc8b7__"